import {
    store
} from '../store/store';
export const _url = url => url + (url.indexOf('?') === -1 ? '?' : '&') + 'cuid=' + (store.getters.currentUser ? store.getters.currentUser.id : 0);
